import VirtualTable from '../VirtualTable';
import { IVirtualizedTableProps } from '../VirtualTable.types';

import styles from './VirtualizedTable.module.scss';

function VirtualizedTable<T extends object>(props: IVirtualizedTableProps<T>): JSX.Element {
  /* eslint-disable react/jsx-props-no-spreading */
  return <VirtualTable className={styles.virtualTable} {...props} />;
}

export default VirtualizedTable;
